import videojs from 'video.js';
const Button = videojs.getComponent('Button');
// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
const onPlayerReady = (player) => {
    player.addClass('vjs-cast-to-tv-button');
    // @ts-expect-error - legit error?
    player.controlBar.settings = player.controlBar.addChild('castToTvButton', {}, 11);
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function castToTvButton
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
const castToTvButton = function () {
    // document.sbInit++;
    this.ready(() => {
        onPlayerReady(this);
    });
};
/**
 * Button to seek forward/back
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class SeekToggle
 */
class CastToTvButton extends Button {
    constructor(player, options) {
        super(player, options);
        if (window === null || window === void 0 ? void 0 : window.WebKitPlaybackTargetAvailabilityEvent) {
            const videoEl = player.el().getElementsByTagName('video')[0];
            videoEl.addEventListener('webkitplaybacktargetavailabilitychanged', (event) => {
                switch (event.availability) {
                    case 'available':
                        this.enable();
                        break;
                }
            });
        }
        else {
            this.disable();
        }
    }
    buildCSSClass() {
        return `vjs-cast-to-tv-button ${super.buildCSSClass()}`;
    }
    handleClick() {
        const firstVideo = this.player().el().getElementsByTagName('video')[0];
        if (firstVideo && firstVideo.webkitShowPlaybackTargetPicker) {
            // apple airplay
            firstVideo.webkitShowPlaybackTargetPicker();
        }
        this.player().trigger('airplayStart');
    }
}
videojs.registerComponent('CastToTvButton', CastToTvButton);
// Register the plugin with video.js.
registerPlugin('castToTvButton', castToTvButton);
export default castToTvButton;
//# sourceMappingURL=CastToTvButton.js.map